import NoteTab from './NoteTab.vue';

export default NoteTab;
